import {
  loadDataMapListing,
  loadDataMap,
  setContextualSupport,
  unsetContextualSupport,
} from 'js/actions';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { SearchFilterViews } from 'js/constants/visibilityFilters';
import UIUtils from 'js/lib/UIUtils';
import { getEligibleDataMapEntities } from 'js/reducers/selectors';
import { pick } from 'lodash';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { connect } from 'react-redux';
import DataMapDashboard from './DataMapDashboard';

const mapStateToProps = (state, ownProps) => {
  const {
    app: {
      listing: { aclQueryMode, selectedCardId },
      visibilityFilters: { filters },
    },
    dataMaps: { byId },
    request,
  } = state;

  const dataMapId = UIUtils.extractParamFromURL(ownProps.match);

  return {
    dataMaps: getEligibleDataMapEntities(state),
    dataMapId,
    aclQueryMode,
    filters: filters[SearchFilterViews.DATA_MAPS],
    isLoading: request.GET_DATA_MAPS_REQUEST || (request.GET_DATA_MAP_REQUEST && !selectedCardId),
  };
};

const AsyncDataMapDashboardContainer = connect(mapStateToProps, {
  loadDataMapListing,
  loadDataMap,
  setContextualSupport,
  unsetContextualSupport,
})(DataMapDashboard);

AsyncDataMapDashboardContainer.screenConfig = {
  screenName: 'AsyncDataMapDashboardContainer',
  domain: 'integrate',
  path: [`${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DATA_MAPS}`],
  exact: true,
  pageTitle: 'Lookups',
  defaultProps: {
    withHeader: false,
    onlyTableView: true,
  },
};

export default AsyncDataMapDashboardContainer;
